module.exports = __webpack_public_path__ + "img/arrow-up-2.13311abd.svg";